import { RouteProps } from "@/mk2/apps/bazaar/containers/ProductDetail/ProductDetailPage";
import { ProductQuality } from "@/mk2/apps/bazaar/schemas";
import { HistoryLocationState } from "@/mk2/services/browserHistory";

export const REVIEW_FORM = (buyerId: number) => `reviewForm_${buyerId}`;
export const REVIEW_REPLY_FORM = (reviewId: number) => `reviewReplyForm_${reviewId}`;
export const SELLER_NOTES_FORM = (userId: number) => `sellerNotesForm_${userId}`;
export const MESSAGE_REPLY_FORM = (buyerId: number) => `messageReplyForm_${buyerId}`;
export const CONTACT_SELLER_FORM = (productId: number) => `contactSellerForm_${productId}`;

export function paramsToSlug(params: RouteProps["routeParams"]): string {
    return `${params.category}/${params.hash}/${params.title}`;
}

export function slugToParams(slug: string): RouteProps["routeParams"] {
    const parts = slug.split("/");
    return {
        category: parts[0],
        hash: parts[1],
        title: parts[2],
    };
}

export interface NavigationHistoryState extends HistoryLocationState {
    fromProductDetail?: boolean;
}

const MULTISELECT_PROPS_WITH_QUALITY = [
    "new-p_size",
    "new-p_color",
    "handmade-p_size",
    "handmade-p_color",
    "services-p_age_years",
    "services-p_for_whom",
    "services-p_frequency",
    "services-p_level",
    "services-p_place",
    "services-p_school_subject",
    "services-p_space_type",
];

const MULTISELECT_PROPS = [
    "p_sex",
    "p_isofix",
    "p_seat_facing",
    "p_brand_models",
    "p_fits_on_model",
];

export function isMultiselectProperty(quality: ProductQuality, property: string): boolean {
    return (
        MULTISELECT_PROPS_WITH_QUALITY.includes(`${quality}-${property}`) ||
        MULTISELECT_PROPS.includes(property)
    );
}
